/* eslint-disable */
import { Box, InputLabel, MenuItem, Select } from '@material-ui/core';
import PropTypes from 'prop-types';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import styles from './CustomSelect.module.css';

const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&&&.Mui-selected': {
            backgroundColor: '#000000',
            color: '#fff',
            '&:hover': {
              backgroundColor: '#000000',
            },
          },
        },
      },
    },
  },
});

export const CustomSelect = ({
  id,
  dataTestId,
  required,
  inputLabelAriaLabel = null,
  inputLabelClassName = '',
  label,
  autoFocus,
  options,
  InputClassName,
  handleChange,
  fullWidth,
  value,
  dataTestIdForLabel = null,
  error,
  maskMobile,
  screen,
  mobileLabel,
  phoneLabel,
  emailLabel,
  colon,
  withOutSort,
  addPhoneNumberItem,
  addNewEmailItem,
  selectWithoutHypens,
  englishBot,
}) => {
  const initialLabel = () => {
    if (mobileLabel === 'true') return 'mobile number';
    else if (phoneLabel === 'true') return englishBot ? 'phone number' : 'el número de teléfono';
    else if (emailLabel === 'true') return 'email';
    else return '';
  };
  const menuItemIteration = (option, index) => {
    return (
      <MenuItem
        key={option}
        role="option"
        value={option}
        index={index}
        className={
          screen === 'otp' || screen === 'autopay-settings'
            ? styles.otp_menuitem_style
            : styles.menuitem_style
        }
      >
        {option}
      </MenuItem>
    );
  };
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex' }}>
        <InputLabel
          required={required || false}
          className={`${styles.label_title} ${inputLabelClassName}`}
        >
          {label || ''}
        </InputLabel>
        {colon && <span style={{ lineHeight: '18px' }}>:</span>}
      </Box>
      <Select
        id={id}
        data-testid={dataTestId || ''}
        name={id}
        role="listbox"
        variant="outlined"
        inputProps={{ 'data-testid': id }}
        aria-label={`${label || null} ${required ? 'Required Aria' : ''}`}
        autoFocus={autoFocus || false}
        className={styles.select_inputs}
        onChange={handleChange}
        fullWidth={fullWidth || false}
        value={value || ''}
        IconComponent={KeyboardArrowDownOutlinedIcon}
        displayEmpty
        style={{ height: '48px' }}
      >
        <MenuItem role="option" value="" style={{ color: '#6B6B6B' }}>
          {initialLabel()}
        </MenuItem>
        {withOutSort
          ? options &&
            Object.keys(options).length > 0 &&
            options.map((option, index) => menuItemIteration(option, index))
          : options &&
            Object.keys(options).length > 0 &&
            options.sort().map((option, index) => menuItemIteration(option, index))}
        {addPhoneNumberItem && (
          <MenuItem role="option" value="Add new phone number">
            {englishBot ? 'Add new phone number' : 'Añadir nuevo número de teléfono'}
          </MenuItem>
        )}
        {addNewEmailItem && (
          <MenuItem role="option" value="Add new email">
            {englishBot ? 'Add new email' : 'Añadir nuevo correo electrónico'}
          </MenuItem>
        )}
      </Select>
      {error ? (
        <Box className="errorMsg" role="alert">
          {error}
        </Box>
      ) : (
        ''
      )}
    </ThemeProvider>
  );
};

CustomSelect.propTypes = {
  id: PropTypes.string,
  required: PropTypes.bool,
  inputLabelAriaLabel: PropTypes.string,
  inputLabelClassName: PropTypes.string,
  label: PropTypes.string,
  autoFocus: PropTypes.bool,
  options: PropTypes.array,
  InputClassName: PropTypes.string,
  error: PropTypes.string,
  handleChange: PropTypes.func,
  fullWidth: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataTestId: PropTypes.string,
  dataTestIdForLabel: PropTypes.string,
  colon: PropTypes.string,
  maskMobile: PropTypes.bool,
  screen: PropTypes.string,
  mobileLabel: PropTypes.string,
  phoneLabel: PropTypes.string,
  emailLabel: PropTypes.string,
  withOutSort: PropTypes.bool,
  addPhoneNumberItem: PropTypes.bool,
  addNewEmailItem: PropTypes.bool,
  selectWithoutHypens: PropTypes.bool,
  englishBot: PropTypes.bool,
};
